import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    OnDestroy,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import { ListViewSettingModel } from '@fi-app/components/items-list/list-view-setting.model';
import { FiDisplayType } from '@fi-shared/types/display-type';
import { FiUserListComponent } from '@fi-app/user/user-list/fi-user-list/fi-user-list.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IUserListItemViewModel } from '@fi-app/user/user';

@Component({
    selector: 'fi-sms-users-dialog',
    template: `
        <fi-user-list
            #userListNewComponent
            [userListViewSettings]="data"
            [hideActions]="true"
            [textMode]="true"
            [isNestedList]="true"
            [isSideListShown]="true"
            [listDisplayType]="FiDisplayType.List"
            [onlyWithContactPhones]="true"
            [isRemarkColumnShown]="false"
            [isEmailColumnShown]="true"
            [isPhoneContactColumnShown]="true"
        >
        </fi-user-list>
    `,
    styleUrls: ['./fi-sms-users-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-sms-users-dialog' },
    standalone: false,
})
export class FiSmsUsersDialogComponent
    extends FiDialogsContentBase<ListViewSettingModel, IUserListItemViewModel[]>
    implements AfterViewInit, OnDestroy
{
    @ViewChild('userListNewComponent') userListNewComponent: FiUserListComponent;

    private selectedItems: IUserListItemViewModel[];

    ngAfterViewInit() {
        this.userListNewComponent.selectedItems$.pipe(takeUntil(this.ngOnDestroy$)).subscribe((selectedItems) => {
            this.selectedItems = selectedItems;
        });
    }

    isYesButtonDisabled(): boolean {
        return !this.selectedItems?.length;
    }

    getResult(): any[] {
        return this.selectedItems;
    }

    ngOnDestroy$ = new Subject<void>();
    ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }

    protected readonly FiDisplayType = FiDisplayType;
}
